export const ticketPriceMixin = {
  methods: {
    calcMainTicketPrice(ticketInfo) {
      // if (!ticketInfo) return ''
      if (ticketInfo.isFree) {
        return this.$t('ui.free')
        // return `${ticketInfo.affiliateInfo.affiliateTicketPrice} ₺`
      } else {
        if (ticketInfo.ticketTypes.length > 1) {
          const prices = ticketInfo.ticketTypes.map(type => type.ticketPrice)
          const sorted = prices.sort((a, b) => a - b)
          // if (sorted.length > 1) {
          //  return `${sorted[0].toFixed(2)} - ${sorted[sorted.length-1].toFixed(2)}`
          // }
          return `${sorted[0].toFixed(2)}`
        } else if (ticketInfo.ticketTypes.length) {
          const price = ticketInfo.ticketTypes[0].ticketPrice
          return `${price.toFixed(2)}`
        } else {
          return ``
        }
      }
    },
    calcMinMaxTicketPrices(ticketInfo) {
      // if (!ticketInfo) return ''
      if (ticketInfo.isFree) {
        return this.$t('ui.free')
        // return `${ticketInfo.affiliateInfo.affiliateTicketPrice} ₺`
      } else {
        if (ticketInfo.ticketTypes.length > 1) {
          const prices = ticketInfo.ticketTypes.map(type => type.ticketPrice)
          const sorted = prices.sort((a, b) => a - b)
          if (sorted.length > 1) {
            return `${sorted[0].toFixed(2)} ₺ - ${sorted[sorted.length - 1].toFixed(2)} ₺`
          }
          return `${sorted[0].toFixed(2)} ₺`
        } else if (ticketInfo.ticketTypes.length) {
          const price = ticketInfo.ticketTypes[0].ticketPrice
          return `${price.toFixed(2)} ₺`
        } else {
          return ``
        }
      }
  
    },

  },
 
}